export default __webpack_public_path__ + "static/media/flannel.ffe6d2c7.svg";